class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
    this.errorMessage = document.querySelector(".error-messaging");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    this.cartNotification.setActiveElement(document.activeElement);

    const productAddedEvent = new Event("product:added");
    const quantityContainer = this.form.closest(".product__form").parentNode;
    const submitButton = this.querySelector('[type="submit"]');
    const buttonText = submitButton.querySelector("span");
    const icon = document.querySelector(".header__icon--cart");
    let quantity = document.querySelector(".quantity__input").value;

    if (quantityContainer.querySelector(".quantity__input")) {
      quantity =
        quantityContainer.querySelector(".quantity__input").value || quantity;
    }

    // Find current swatch to get the SKU
    let currentSwatch = document.querySelector(".swatch input:checked");
    if (!currentSwatch) {
      const id = document.querySelector(
        '[data-type="add-to-cart-form"] input[name="id"]'
      ).value;
      currentSwatch = document.querySelector(
        `.product-select option[value="${id}"]`
      );
    }

    const canUpdateQuantity = async (skusToValidate) => {
      let _canUpdateQuantity = true;
      if (window.QuantityLimit) {
        try {
          _canUpdateQuantity = await window.QuantityLimit.validateQuantityLimit(
            skusToValidate
          );
        } catch (e) {
          console.log(e);
        }
      }
      return _canUpdateQuantity;
    };

    const formData = JSON.parse(serializeForm(this.form));
    
    // Add embroidered property to form data. Pending to create a more performant solution to support custom properties.
    let properties = {};
    const embroideredName = document.querySelector(".embroidered__input");
    const embroideredColor = document.querySelector(".embroidered__color");
    const preorder = document.querySelector(
      'input[name="properties[Pre-order]"]'
    );
    const finalSale = document.querySelector(
      'input[name="properties[__FinalSale]"]'
    );
    const productMessaging = document.querySelector(
      'input[name="properties[__ProductMessaging]"]'
    );

    for (const key in formData) {
      if (key.startsWith("__C ")) {
        const data = formData[key]
        if(!data) continue;
        properties[key] = formData[key];
        if(key == "__C Photo") continue;
        properties[key.replace("__C ", "")] = formData[key];
      }
    }

    const embroideredVariantJson = JSON.parse(document.querySelector("[data-embroidered]")?.innerText || "{}");
    const embroideredVariantId = embroideredVariantJson.embroidered_variant_id;
    const excludedProducts = embroideredVariantJson?.embroidered_product_exclusions || [];
    if (embroideredName && embroideredName.value !== "") {
      properties["_embroidered_name"] = embroideredName.value;
      properties["Embroidered Name"] = embroideredName.value;
      properties["_LPROP"] = "Final Sale";
      if (embroideredColor && embroideredColor.value !== "") {
        properties["_embroidered_color"] = embroideredColor.value;
        properties["Embroidered Color"] = embroideredColor.value;
      }
    }
    if (embroideredVariantId && embroideredName && embroideredName.value !== "") {
      properties[embroideredName.dataset.propertyName] = embroideredName.value;
      properties["_embroidered_name"] = embroideredName.value;
      properties["_embroidered_id"] = `emb-${Math.floor(Math.random() * 10000) + 1}`
      properties["_embroidered_main"] = "true";
      properties["_LPROP"] = "Final Sale";
    }
    if (preorder) {
      properties["Pre-order"] = preorder.value;
    }
    if (finalSale) {
      properties["__FinalSale"] = finalSale.value;
    }
    if (productMessaging) {
      properties["__ProductMessaging"] = productMessaging.value;
    }
    // Add gift card properties
    const gcContainer = document.querySelector("[data-gift-card-container]");
    if (gcContainer) {
      const inputErrorMesasge = gcContainer.querySelector(
        ".inputs-required-error"
      );
      const gcRecipient = gcContainer.querySelector("#gc_recipient").value;
      const gcMessage = gcContainer.querySelector("#gc_message").value;

      inputErrorMesasge.classList.remove("show");

      // validate empty fields
      if (!gcRecipient || !gcMessage) {
        inputErrorMesasge.classList.add("show");
        return false;
      }

      // validate gift card fields before adding to cart return false if not valid
      if (
        gcContainer.querySelector("#gc_recipient").classList.contains("error")
      ) {
        gcContainer.querySelector("#gc_recipient").classList.add("red-border");
        gcContainer.querySelector("#gc_recipient").focus();
        return false;
      }

      if (gcRecipient !== "" && gcMessage !== "") {
        properties["GC Recipient"] = gcRecipient;
        properties["GC Message"] = gcMessage;
        properties["_gc_timestamp"] = Date.now() + Math.random();
      }
    }

    canUpdateQuantity({
      [currentSwatch.dataset.sku]: quantity,
    }).then((canUpdate) => {
      if (canUpdate) {
        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        buttonText.dataset.text = buttonText.innerText;
        buttonText.innerText = "Adding";
        if (this.errorMessage) {
          this.errorMessage.style.display = "none";
        }

        const body = JSON.stringify({
          ...formData,
          quantity,
          properties,
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig("javascript"),
          body,
        })
          .then(async (response) => {
            if (!response.ok) {
              if (response.status === 422) {
                const res = await response.json();
                throw new Error(res.message);
              }
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            buttonText.innerText = "Added";
            const screenReaderMessage = document.createElement("div"); // Create a new div element to announce "cart has been updated" to screen readers
            screenReaderMessage.textContent = "Cart has been updated.";
            screenReaderMessage.setAttribute("aria-live", "polite");
            screenReaderMessage.classList.add("screen-reader-message");
            document.body.appendChild(screenReaderMessage);
            document.dispatchEvent(productAddedEvent);

        
            const isExcluded = excludedProducts.find((product) => product.variants.find((variant) => variant.id == formData.id));
           
            if (!isExcluded && embroideredVariantId && properties["_embroidered_name"] && properties["_embroidered_name"] !== "") {
              fetch(`${routes.cart_add_url}`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: embroideredVariantId,
                  properties: Object.assign({
                    _embroidered_name: properties["_embroidered_name"],
                    _embroidered_id: properties["_embroidered_id"],
                    _LPROP: "Final Sale"
                  }, !!properties?._embroidered_color ? {
                    _embroidered_color: properties._embroidered_color,
                    'Embroidered Color': properties._embroidered_color
                  } : {})
                }),
              }).then((response) => response.json());
            }

            if (icon) {
              icon.classList.add("active");
              //update number in header
              fetch("/cart.js")
                .then((response) => response.json())
                .then((data) => {
                  icon
                    .querySelectorAll(".cart-count-bubble span")
                    .forEach((el) => {
                      el.innerText = data.item_count;
                    });
                });
            }
            setTimeout(() => {
              buttonText.innerText = buttonText.dataset.text;
              if (icon) {
                icon.classList.remove("active");
              }
              // open minicart
              this.miniCart = document.querySelector("[data-mini-cart-panel]");
              this.openMiniCart = new CustomEvent("openMiniCart");
              this.minicartPanel = new window.Panel({
                el: document.querySelector("[data-mini-cart-panel]"),
              });
              this.miniCart.dispatchEvent(this.openMiniCart);
              this.minicartPanel.open();
            }, 1000);
          }).catch((e) => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            buttonText.innerText = buttonText.dataset.text;
            if (this.errorMessage) {
              this.errorMessage.style.display = "block";
              this.errorMessage.innerText = e.message;
            }
          });
      }
    });
  }
}
customElements.define("product-form", ProductForm);
